import api from './api';

export interface ContactRequest {
  id: number;
  customer_id?: number;
  name: string;
  email?: string;
  phone: string;
  motive: 'entretien' | 'reclamation' | 'information_commerciale' | 'autre';
  message: string;
  preferred_channel: 'phone' | 'email' | 'chat';
  preferred_time: 'morning' | 'afternoon';
  urgency_level: 'low' | 'medium' | 'high' | 'critical';
  status: 'pending' | 'in_progress' | 'resolved';
  resolution_notes?: string;
  created_at: string;
  updated_at: string;
  customer?: {
    id: number;
    first_name: string;
    last_name: string;
    user?: {
      email: string;
    };
  };
}

export interface ContactRequestsFilters {
  status?: string;
  motive?: string;
  urgencyLevel?: string;
  page?: number;
  limit?: number;
}

export interface ContactRequestsResponse {
  success: boolean;
  data: ContactRequest[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

class ContactRequestsService {
  async getContactRequests(filters: ContactRequestsFilters = {}): Promise<ContactRequestsResponse> {
    try {
      const response = await api.get('/contact-requests', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des demandes de contact:', error);
      throw error;
    }
  }

  async updateContactRequest(
    id: number,
    data: { urgencyLevel?: string; status?: string; notes?: string; resolutionNotes?: string }
  ): Promise<ContactRequest> {
    try {
      const response = await api.patch(`/contact-requests/${id}`, data);
      return response.data.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la demande ${id}:`, error);
      throw error;
    }
  }
}

export const contactRequestsService = new ContactRequestsService();
